<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>{{ data.title }}</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<form [formGroup]="contactForm">
		<div class="full-width">
			<div fxLayout="row" *ngIf="loadingContactsList" fxLayoutAlign="center center">
				<mat-spinner [diameter]="30"></mat-spinner>
			</div>
			<div *ngIf="!loadingContactsList" class="m-t-1">
				<mat-form-field class="example-full-width" appearance="fill" fxFlex>
					<mat-label>Select Contact</mat-label>
					<input type="text" matInput formControlName="contact" [matAutocomplete]="auto" />
					<mat-autocomplete
						autoActiveFirstOption
						#auto="matAutocomplete"
						[displayWith]="displayContact"
					>
						<mat-option *ngFor="let option of filteredOptions | async" [value]="option">
							{{ option.firstName || '' }} {{ option.lastName || '' }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</div>
		</div>
	</form>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
		<button (click)="addNewContact()" color="primary" mat-raised-button>Add New Contact</button>
		<button
			(click)="submitContact()"
			[disabled]="contactForm.invalid"
			color="primary"
			mat-raised-button
		>
			Set Contact
		</button>
	</div>
</mat-dialog-actions>
